<template>
  <div style="width: 100%; background: #fff; flex: 1">
    <div class="mainBox">
      <div class="mainBox-nav">
        <div
          v-for="(item, index) in navList"
          :class="[
            'mainBox-navList',
            navIndex >= index ? ' active' : '',
            navIndex >= index + 1 ? 'activeF' : '',
          ]"
          :key="index"
          @click="changeNav(index)"
        >
          <div class="mainBox-navText">{{ item }}</div>
        </div>
      </div>
      <div class="breadcrumb" v-if="navIndex == 0">
        个人中心>设置>安全管理><span style="color: #e4670c">手机绑定</span>
      </div>
      <div class="mainBox-form" v-if="navIndex == 0">
        <div class="mainBox-label">
          <span class="formLabel">手机号：</span>
          <span class="formLabel">短信验证码：</span>
        </div>
        <div class="mainBox-tips">
          <span class="formTips"
            >请输入11位手机号码（此号码为接收短信号码）</span
          >
        </div>
        <div class="mainBox-formList">
          <input class="search-input" type="text" v-model="phone" />
        </div>
        <div class="mainBox-formList">
          <input
            class="search-input"
            type="text"
            style="width: 190px; margin-right: 15px"
            v-model="verificationCode"
          /><button class="codeBtn" @click="sendCode()" :disabled="disable">
            {{ content }}
          </button>
        </div>
        <button class="mainBox-btn" @click="handleRegister()">确定</button>
      </div>

      <div class="mainBox_examine" v-if="navIndex == 1">
        <img
          src="/static/image/success.png"
          alt=""
          class="mainBox_examineImg"
        />
        <div class="mainBox_examineText">手机绑定成功！</div>
        <div class="mainBox_examineTip">
          {{ countdown }}s后自动跳转到<span
            style="color: #f89a00; cursor: pointer"
            @click="$router.push('/personal')"
            >个人中心</span
          >页面
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doGet, postAction } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  data() {
    return {
      navList: ["手机绑定", "完成"],
      navIndex: 0,

      phone: "",
      verificationCode: "",
      content: "发送验证码",
      totalTime: 60,
      disable: false,

      countdown: 3,
    };
  },
  mounted() {},
  methods: {
    changeNav(index) {
      // this.navIndex = index;
    },
    /**
     * 发送验证码
     */
    sendCode() {
      var that = this;
      if (this.phone) {
        if (this.disable) return; // 改动的是这两行代码

        var myreg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!myreg.test(that.phone)) {
          that.$message({
            message: "请输入正确的手机号",
            type: "warning",
          });
          return;
        }

        this.disable = true;
        this.content = this.totalTime + "s后重新发送";
        const clock = window.setInterval(() => {
          this.totalTime--;
          this.content = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            window.clearInterval(clock);
            this.content = "发送验证码";
            this.totalTime = 60;
            this.disable = false; // 这里重新开启
          }
        }, 1000);
        doGet(
          httpConfig.Login.getCodeUrl,
          { phone: this.phone },
          function (res) {
            if (res.flag) {
              that.$message({
                message: res.message || "发送成功",
                type: res.message ? "warning" : "success",
              });
            } else {
              that.$message({
                message: res.message,
                type: "warning",
              });
            }
          },
          function (res) {}
        );
      } else {
        this.$message({
          message: "请先输入手机号",
          type: "warning",
        });
      }
    },
    /**
     * 确认注册
     */
    handleRegister() {
      var that = this;
      if (that.phone) {
        if (that.verificationCode) {
          postAction(
            httpConfig.bindPhone.editPhoneNoUrl,
            {
              id: that.$cookies.get("peopleId"),
              phone: that.phone,
              verificationCode: that.verificationCode,
            },
            function (res) {
              if (res.flag) {
                var data = JSON.parse(
                  JSON.stringify(that.$cookies.get("userInfo"))
                );
                data.phone = that.phone;
                that.$cookies.set("userInfo", JSON.stringify(data));
                that.navIndex = 1;
                const clock = window.setInterval(() => {
                  that.countdown--;
                  if (that.countdown <= 0) {
                    window.clearInterval(clock);
                    that.$router.push("/personal");
                  }
                }, 1000);
              } else {
                that.$message({
                  message: res.message,
                  type: "warning",
                });
              }
            },
            function (res) {}
          );
        } else {
          that.$message({
            message: "请输入验证码",
            type: "warning",
          });
        }
      } else {
        that.$message({
          message: "请输入手机号",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/bindPhone";
</style>



// WEBPACK FOOTER //
// src/components/page/bindPhone.vue